import React from 'react';

const CalendarButtonIcon = props => (
  <svg width={12} height={8} {...props}>
    <path
      d='M1 2.59l4.29 4.24a1 1 0 001.42 0l4.24-4.24a1 1 0 10-1.41-1.42L6 4.71 2.46 1.17a1 1 0 00-1.41 0A1 1 0 001 2.59z'
      fill='#000'
      fillRule='nonzero'
    />
  </svg>
);

export default CalendarButtonIcon;
